/**
 * Schema of Responsavel
 * @author Simpli CLI generator
 */
import {InputType, Schema} from 'simpli-web-sdk'
import {bool, cnpj, datetime, date, phone} from 'simpli-web-sdk'
import Responsavel from '@/model/resource/Responsavel'
import RenderResponsavelAction from '@/components/render/responsavel/RenderResponsavelAction.vue'
import RenderData from '@/components/render/RenderData.vue'
import RenderLabelValue from '@/components/render/RenderLabelValue.vue'

export default (model: Responsavel): Schema => ({
  actions: {
    content: {
      component: RenderResponsavelAction,
      props: {
        model,
      },
    },
    textContent: null,
  },

  endereco: {
    content: model.endereco && model.endereco.toString(),
    input: InputType.SELECT,
  },

  responsavelFilial: {
    content: model.responsavelFilial && model.responsavelFilial.$id,
    input: InputType.SELECT,
  },

  responsavelResponsavel: {
    hidden: true,
    input: InputType.SELECT,
  },

  idResponsavelPk: {
    content: {
      component: RenderLabelValue,
      props: {
        value: model.idResponsavelPk,
        tagClass: 'default',
      },
    },
    editable: false,
  },

  cnpj: {
    content: {
      component: RenderData,
      props: {
        value: cnpj(model.cnpj),
        innerClass: 'inline-word',
      },
    },
    input: InputType.CNPJ,
    meta: {
      required: true,
    },
  },

  urlLogoEmpresa: {
    content: model.urlLogoEmpresa,
    input: InputType.TEXT,
    meta: {
      maxlength: '255',
    },
  },

  razaoSocial: {
    content: model.razaoSocial,
    input: InputType.TEXT,
    meta: {
      required: true,
      maxlength: '255',
    },
  },

  nomeFantasia: {
    content: model.nomeFantasia,
    input: InputType.TEXT,
    meta: {
      required: false,
      maxlength: '255',
    },
  },

  nomeContato: {
    content: model.nomeContato,
    input: InputType.TEXT,
    meta: {
      required: true,
      maxlength: '255',
    },
  },

  telefone: {
    content: {
      component: RenderData,
      props: {
        value: phone(model.telefone),
        innerClass: 'inline-word',
      },
    },
    input: InputType.PHONE,
    meta: {
      required: false,
    },
  },

  email: {
    content: model.email,
    input: InputType.EMAIL,
    meta: {
      required: true,
    },
  },

  dataVencimento: {
    content: date(model.dataVencimento),
    input: InputType.DATE,
    meta: {
      required: true,
    },
  },

  jaRedefiniuSenha: {
    content: bool(model.jaRedefiniuSenha),
    input: InputType.CHECKBOX,
  },

  apenasVisualizacao: {
    content: bool(model.apenasVisualizacao),
    input: InputType.CHECKBOX,
  },

  ehFilial: {
    content: bool(model.ehFilial),
    input: InputType.CHECKBOX,
  },

  dataCriacao: {
    content: datetime(model.dataCriacao),
    input: InputType.DATETIME,
    meta: {
      required: true,
    },
  },

  criadoPeloAdmin: {
    content: bool(model.criadoPeloAdmin),
    input: InputType.CHECKBOX,
  },

  ativo: {
    content: bool(model.ativo),
    hidden: true,
    editable: false,
  },

  senha: {
    content: model.senha,
    hidden: true,
    input: InputType.PASSWORD,
  },

  senhaVisualizador: {
    content: model.senhaVisualizador,
    hidden: true,
    input: InputType.TEXT,
    meta: {
      maxlength: '255',
    },
  },

  senhaAdmin: {
    content: model.senhaAdmin,
    hidden: true,
    input: InputType.TEXT,
    meta: {
      maxlength: '255',
    },
  },

  senhaSac: {
    content: model.senhaSac,
    hidden: true,
    input: InputType.TEXT,
    meta: {
      maxlength: '255',
    },
  },

  permitirAssociado: {
    content: bool(model.permitirAssociado),
    input: InputType.CHECKBOX,
  },

  permitirSerialNumber: {
    content: bool(model.permitirSerialNumber),
    input: InputType.CHECKBOX,
  },

  receberNotificacoesCarga: {
    content: bool(model.receberNotificacoesCarga),
    input: InputType.CHECKBOX,
  },

  receberNotificacoesTrajeto: {
    content: bool(model.receberNotificacoesTrajeto),
    input: InputType.CHECKBOX,
  },

  permitirDataPrevisao: {
    content: bool(model.permitirDataPrevisao),
    input: InputType.CHECKBOX,
  },

  permitirBotaoNaoEntregarCarga: {
    content: bool(model.permitirBotaoNaoEntregarCarga),
    input: InputType.CHECKBOX,
  },

  servoIndependente: {
    content: bool(model.servoIndependente),
    input: InputType.CHECKBOX,
  },

  auditoriaCepCheckInEmMetros: {
    content: model.auditoriaCepCheckInEmMetros,
    input: InputType.NUMBER,
    meta: {
      required: true,
      step: 'any',
    },
  },

  auditoriaCepEntregaEmMetros: {
    content: model.auditoriaCepEntregaEmMetros,
    input: InputType.NUMBER,
    meta: {
      required: true,
      step: 'any',
    },
  },

  urlImgCabecalho: {
    content: model.urlImgCabecalho,
    input: InputType.TEXT,
    meta: {
      maxlength: '255',
    },
  },

  urlImgRodape: {
    content: model.urlImgRodape,
    input: InputType.TEXT,
    meta: {
      maxlength: '255',
    },
  },

  nomeSaraivaFtp: {
    content: model.nomeSaraivaFtp,
    input: InputType.TEXT,
    meta: {
      maxlength: '255',
    },
  },

  limitarConsulta: {
    content: bool(model.limitarConsulta),
    input: InputType.CHECKBOX,
  },

  versaoLight: {
    content: bool(model.versaoLight),
    input: InputType.CHECKBOX,
  },
})
